module.exports = __webpack_public_path__ + "img/BCN.525f33e3.svg";